function tabSet(tabNode) {
  const tabs = tabNode.querySelectorAll('.ed-tabs__tab');
  const contentsWrapper = tabNode.querySelector('.ed-tabs__contents');
  const contents = tabNode.querySelectorAll('.ed-tabs__content');

  function toggleTabs(event, key) {
    // Change Toggle Tab Classes
    let currentActive = tabNode.querySelector('.ed-tabs__tab--selected');
    currentActive.classList.remove('ed-tabs__tab--selected');
    event.target.classList.add('ed-tabs__tab--selected'); // Change Content Classes

    let currentActiveContent = tabNode.querySelector('.ed-tabs__content--active');
    const tabToggleBoxes = tabNode.querySelectorAll('.ed-tabs__content');
    currentActiveContent.classList.remove('ed-tabs__content--active');
    tabToggleBoxes[key].classList.add('ed-tabs__content--active');
  }

  // Add click event for toggle
  tabs.forEach((tab, key) => {
    tab.addEventListener('click', (event) => {
      toggleTabs(event, key);
    });
  });

  // Set min height on contents wrapper to prevent page from jumping when tabs are not the same lenght
  const setContentHeight = (wrapper) => {
    const height = Array.from(contents).reduce((a, b) =>
      a.scrollHeight > b.scrollHeight ? a.scrollHeight : b.scrollHeight
    );
    wrapper.style.minHeight = `${height}px`;
  };

  setContentHeight(contentsWrapper);
  const resizeObserver = new ResizeObserver(() => {
    setContentHeight(contentsWrapper);
  });
  resizeObserver.observe(tabNode);
}

const tabSets = document.querySelectorAll('.ed-tabs');
tabSets.forEach(function (_tabSet) {
  tabSet(_tabSet);
});
